import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { updateSelectedNetworkGroup } from '@/features/analysisMapSlice';
import { ViewModeOptions } from '@/features/types';
import {
  useFetchNetworkGroupsQuery,
  useFetchNetworkGroupsWithValuesQuery,
} from '@/features/networkGroupSlice';
import { useEffect, useRef } from 'react';
import { NetworkGroupType } from '@/generated/types/navigator/types.gen';
import { UNGROUPED, hasNetworkGroupType } from '@/helpers/networkGroups';

export const useSelectInitialNetworkGroup = () => {
  const dispatch = useAppDispatch();
  const hasFetchedData = useRef(false);

  const { data: networkGroups, isSuccess: isFetchNetworkGroupSuccess } =
    useFetchNetworkGroupsQuery();

  // Kick off the values query in the background for when users eventually filter
  useFetchNetworkGroupsWithValuesQuery();
  const { selectedNetworkGroup, currentViewMode } = useAppSelector(
    (state) => state.analysisMap
  );

  const defaultNetworkGroup =
    networkGroups?.find((group) =>
      hasNetworkGroupType(group, NetworkGroupType.PLANNING)
    ) ?? UNGROUPED;

  // This is for setting the selected network group on the initial load.
  useEffect(() => {
    if (currentViewMode?.mode !== ViewModeOptions.LEGACY) {
      return;
    }

    if (!hasFetchedData.current && isFetchNetworkGroupSuccess) {
      if (selectedNetworkGroup?.id) {
        // don't try and reset network group everytime the map reloads
        return;
      }

      // on initial API calls, to set the default network group (= planning group)
      hasFetchedData.current = true;
      dispatch(updateSelectedNetworkGroup(defaultNetworkGroup));
    }
  }, [
    defaultNetworkGroup,
    dispatch,
    selectedNetworkGroup,
    hasFetchedData,
    isFetchNetworkGroupSuccess,
    currentViewMode,
  ]);
};
